var pt_br = {
    values: {
        'Others Data': 'Outros Dados',
        'Region Performance': 'Performance na Região'
    }
}

module.exports = pt_br
